import { createFileRoute, redirect } from '@tanstack/react-router';
import React from 'react';

export const Route = createFileRoute('/fleet/')({
  beforeLoad: ({ context }) => {
    // Redirect to login if user is not authenticated
    if (context.authentication.status === 'UNAUTHENTICATED') {
      throw redirect({
        to: '/login',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello &quot;/fleet/&quot;!</div>;
}
